
import _ from "lodash";
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";

export default {
  name: "relatorio-inadimplencia",
  components: { VueSelect },
  mixins: [PessoaMixin],
  data() {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const dia = String(hoje.getDate()).padStart(2, "0");

    return {
      loading: false,
      exportando: null,
      erro: null,
      dados: null,
      inadimplentes: [],
      pessoas: [],
      pessoaSelecionada: null,
      filtros: {
        tipo: "TODOS",
        data_inicial: `${ano}-${mes}-01`,
        data_final: `${ano}-${mes}-${dia}`,
        faixa_atraso: "TODOS",
        id_pessoa: null,
        valor_minimo: null,
      },
      tipos: [
        { value: "TODOS", text: "Todos" },
        { value: "CLIENTE_FINAL", text: "Cliente final" },
        { value: "PARCEIRO", text: "Parceiro" },
      ],
      faixas: [
        { value: "TODOS", text: "Todas" },
        { value: "1_7", text: "1 a 7 dias" },
        { value: "8_15", text: "8 a 15 dias" },
        { value: "16_30", text: "16 a 30 dias" },
        { value: "31_60", text: "31 a 60 dias" },
        { value: "61_90", text: "61 a 90 dias" },
        { value: "MAIS_90", text: "Acima de 90 dias" },
      ],
      camposAging: [
        { key: "descricao", label: "Faixa" },
        { key: "cliente_final", label: "Cliente final", class: "text-right" },
        { key: "parceiros", label: "Parceiros", class: "text-right" },
        { key: "total", label: "Total", class: "text-right" },
        { key: "quantidade_titulos", label: "Títulos", class: "text-right" },
      ],
      camposInadimplentes: [
        { key: "nome", label: "Nome" },
        { key: "tipo", label: "Tipo" },
        { key: "vendedores", label: "Vendedor" },
        { key: "vencimento_mais_antigo", label: "Vencimento mais antigo" },
        { key: "dias_maior_atraso", label: "Maior atraso", class: "text-right" },
        {
          key: "quantidade_titulos_vencidos",
          label: "Títulos",
          class: "text-right",
        },
        { key: "valor_vencido", label: "Valor vencido", class: "text-right" },
        {
          key: "percentual_sobre_total",
          label: "% do total",
          class: "text-right",
        },
        { key: "acoes", label: "", class: "text-right" },
      ],
      camposTitulos: [
        { key: "documento", label: "Título" },
        { key: "historico", label: "Histórico" },
        { key: "vendedora", label: "Vendedor" },
        { key: "data_vencimento", label: "Vencimento" },
        { key: "dias_atraso", label: "Atraso", class: "text-right" },
        { key: "saldo", label: "Saldo", class: "text-right" },
      ],
    };
  },
  computed: {
    ...mapGetters(["isNuts"]),
    temDados() {
      return this.numero(this.dados?.resumo?.valor_total) > 0;
    },
  },
  mounted() {
    if (!this.isNuts) {
      this.$router.replace({ name: "relatoriosFinanceiro" });
      return;
    }
    this.gerarRelatorio();
  },
  methods: {
    payload() {
      return Object.keys(this.filtros).reduce((payload, chave) => {
        const valor = this.filtros[chave];
        if (valor !== null && valor !== "") payload[chave] = valor;
        return payload;
      }, {});
    },
    filtrosValidos() {
      if (!!this.filtros.data_inicial !== !!this.filtros.data_final) {
        this.$toast.warning("Informe a data inicial e final.");
        return false;
      }
      return true;
    },
    async gerarRelatorio() {
      if (!this.filtrosValidos()) return;

      this.loading = true;
      this.erro = null;
      try {
        const response = await this.$http.post(
          "/relatorios/inadimplencia",
          this.payload()
        );
        this.dados = response.data;
        this.inadimplentes = (response.data.inadimplentes || []).map((item) => ({
          ...item,
          _showDetails: false,
          titulos: null,
          carregandoTitulos: false,
          erroTitulos: null,
        }));
      } catch (error) {
        this.erro = this.mensagemErro(error);
      } finally {
        this.loading = false;
      }
    },
    async abrirPdf() {
      if (!this.filtrosValidos()) return;

      const janela = window.open("", "_blank");
      this.exportando = "pdf";
      try {
        const response = await this.$http.post(
          "/relatorios/inadimplencia/pdf",
          this.payload(),
          { responseType: "blob" }
        );
        const arquivo = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(arquivo);
        if (janela) {
          janela.location.href = url;
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.download = "relatorio-inadimplencia.pdf";
          link.click();
        }
        window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (error) {
        if (janela) janela.close();
        this.$toast.error(this.mensagemErro(error));
      } finally {
        this.exportando = null;
      }
    },
    async exportarXlsx() {
      if (!this.filtrosValidos()) return;

      this.exportando = "xlsx";
      try {
        const response = await this.$http.post(
          "/relatorios/inadimplencia/xlsx",
          this.payload(),
          { responseType: "blob" }
        );
        const arquivo = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(arquivo);
        const link = document.createElement("a");
        link.href = url;
        link.download = "relatorio-inadimplencia.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error(this.mensagemErro(error));
      } finally {
        this.exportando = null;
      }
    },
    selecionarPessoa(pessoa) {
      this.filtros.id_pessoa = pessoa?.id_pessoa || null;
    },
    buscarPessoa(search, loading) {
      const termo = String(search || "").trim();
      if (termo.length < 3) {
        this.buscarPessoaRemota.cancel();
        this.pessoas = [];
        loading(false);
        return;
      }
      loading(true);
      this.buscarPessoaRemota(loading, termo, this);
    },
    buscarPessoaRemota: _.debounce(async (loading, termo, vm) => {
      try {
        vm.pessoas = await vm.getClientes(termo);
      } finally {
        loading(false);
      }
    }, 400),
    async alternarTitulos(item, toggleDetails) {
      if (item._showDetails || item.titulos) {
        toggleDetails();
        return;
      }

      this.$set(item, "carregandoTitulos", true);
      this.$set(item, "erroTitulos", null);
      try {
        const response = await this.$http.post(
          "/relatorios/inadimplencia/titulos",
          {
            ...this.payload(),
            tipo: item.tipo,
            id_pessoa: item.id,
          }
        );
        this.$set(item, "titulos", response.data.titulos || []);
        toggleDetails();
      } catch (error) {
        this.$set(item, "erroTitulos", this.mensagemErro(error));
        toggleDetails();
      } finally {
        this.$set(item, "carregandoTitulos", false);
      }
    },
    numero(valor) {
      const numero = Number(valor);
      return Number.isFinite(numero) ? numero : 0;
    },
    moeda(valor) {
      return this.numero(valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    percentual(valor) {
      return `${this.numero(valor).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}%`;
    },
    percentualSeguro(valor) {
      return Math.max(0, Math.min(100, this.numero(valor)));
    },
    inteiro(valor) {
      return Math.trunc(this.numero(valor)).toLocaleString("pt-BR");
    },
    data(valor) {
      if (!valor) return "-";
      const [ano, mes, dia] = String(valor).slice(0, 10).split("-");
      return ano && mes && dia ? `${dia}/${mes}/${ano}` : "-";
    },
    rotuloTipo(tipo) {
      return tipo === "CLIENTE_FINAL" ? "Cliente final" : "Parceiro";
    },
    mensagemErro(error) {
      return (
        error?.response?.data?.message ||
        error?.response?.data?.msg ||
        "Não foi possível gerar o relatório. Tente novamente."
      );
    },
  },
};
